import { API } from 'src/api';

export const updateSheet = async (id: string, payload) => {
  try {
    const response = await API.put(`/sheets`, {
      id,
      data: payload,
    });
    if (response) {
      return response.data;
    }
  } catch (error) {
    console.error('error', error);
    return null;
  }
};
